import { defineAbilitiesFor } from "@/libs/acl/ability";
import { clearStorage } from "@/util/localStorage";
import ability from "@/libs/acl/ability";

export default {
    namespaced: true,
    state: {
        user: null,
        role: null,
        rules: null
    },
    getters: {
        user(state) {
            return state.user;
        },
        role(state) {
            return state.role;
        },
        rules(state) {
            return state.rules;
        }
    },
    mutations: {
        createSession(state, value) {
            state.user = value;
            state.role = value.role;
            state.rules = defineAbilitiesFor(value);
            ability.update(state.rules);
        },
        updateUser(state, value) {
            state.user = value;
        },
        destroySession(state, value) {
            state.user = null;
            state.role = null;
            state.rules = null;
            clearStorage();
        }
    },
    actions: {}
};
